module.exports = __webpack_public_path__ + "img/Porsche-dwgs2-lnk-21-crop.00d20bf5.png";